(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
  const centerPayPal = () => {
    const message = document.getElementById('paypal-upstream-messaging-product');
    if (!message?.closest('form')?.querySelector('.product-form__buttons')) return;
    for (const attribute of ['data-pp-style-align', 'data-pp-style-text-align']) {
      if (message.getAttribute(attribute) !== 'center') message.setAttribute(attribute, 'center');
    }
  };
  centerPayPal();
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1 && (node.id === 'paypal-upstream-messaging-product' || node.querySelector('#paypal-upstream-messaging-product'))) {
          centerPayPal();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
